import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const Inbox01 = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="inbox-01">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.25 4C4.55964 4 4 4.55964 4 5.25V13.25H7.5C7.77368 13.25 8.0354 13.3622 8.22414 13.5603L9.42857 14.825H14.5714L15.7759 13.5603C15.9646 13.3622 16.2263 13.25 16.5 13.25H20V5.25C20 4.55964 19.4404 4 18.75 4H5.25ZM22 5.25C22 3.45507 20.5449 2 18.75 2H5.25C3.45507 2 2 3.45507 2 5.25V18.75C2 20.5449 3.45507 22 5.25 22H18.75C20.5449 22 22 20.5449 22 18.75V5.25ZM20 15.25H16.9286L15.7241 16.5147C15.5354 16.7128 15.2737 16.825 15 16.825H9C8.72632 16.825 8.4646 16.7128 8.27586 16.5147L7.07143 15.25H4V18.75C4 19.4404 4.55964 20 5.25 20H18.75C19.4404 20 20 19.4404 20 18.75V15.25Z"
                    className="fill-current"
                />
            </g>
        </SvgIcon>
    );
};
